import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { LensPackage } from '../meta/IBrain';
import { sunRule } from '../utils/functions';

export default function useCurrentCategory() {
  const packages = useSelector(
    (state: any): LensPackage[] => state.config.packages
  );
  const category = useMemo(() => {
    const pkgs = packages?.filter(
      (pkg: LensPackage) =>
        pkg.lensPackage?.type?.toLowerCase() !== 'frame only'
    );
    return (
      (pkgs?.every((p) => sunRule(p.lensPackage)) && 'SUNGLASSES') ||
      (pkgs?.every((p) => !sunRule(p.lensPackage)) && 'EYEGLASSES') ||
      'MIX&MATCH'
    );
  }, [packages]);
  return category;
}
